<template>
  <div class="">
    <van-button @click="gotoMarket">交易</van-button>
    <van-button @click="gotoSell">出售</van-button>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {},
  created () {},
  mounted () {},
  methods: {
    gotoMarket() {
        this.$router.push({
            name: 'home'
        })
    },
    gotoSell(){
        this.$router.push({
            name: 'sell'
        }) 
    }
  },
  watch: {},
}
</script>

<style lang="less" scoped></style>
